import { createGlobalStyle } from "styled-components";
import reset from "./reset";

export const GlobalStyle = createGlobalStyle`${reset}`;
